import { render, staticRenderFns } from "./gameModal.vue?vue&type=template&id=46ea9ac3&scoped=true"
import script from "./gameModal.vue?vue&type=script&lang=js"
export * from "./gameModal.vue?vue&type=script&lang=js"
import style0 from "./gameModal.vue?vue&type=style&index=0&id=46ea9ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea9ac3",
  null
  
)

export default component.exports